import type {AssortmentStatus, ChortkeFilter} from '../../types';

import {Chip} from '@ds/components';

type AssortmentFiltersProps = {
  filters: ChortkeFilter[];
  onChange: (status: AssortmentStatus, selected: boolean) => void;
};

const AssortmentFilters: React.FC<AssortmentFiltersProps> = ({filters, onChange}) => {
  return (
    <div className="min-h-12 overflow-x-auto border-b border-gray-02 px-4 py-2">
      <div className="flex w-max gap-2">
        {filters.map((filter) => (
          <Chip
            key={filter.status}
            label={filter.title}
            selected={filter.selected}
            onClick={() => onChange(filter.status, !filter.selected)}
          />
        ))}
      </div>
    </div>
  );
};

export default AssortmentFilters;
